module.exports = __webpack_public_path__ + "static/media/03liechesiji2.e834d128.png";